// extracted by mini-css-extract-plugin
export default {"dateCell":"tags-table-row_dateCell__ueBei","name":"tags-table-row_name__LUP85"};